/// <reference path="../definitions/irep/irep.d.ts" />
/// <reference path="../public/irep.ts" />
/// <reference path="../public/component.ts"/>

declare var irep: IREP.IREP;

namespace IREP {
    export class Login35 {
        private $showLoginBtn: JQuery;
        private $closeLoginBtn: JQuery;
        private $showLoginBtnMobile: JQuery;
        private $closeLoginBtnMobile: JQuery;
        private $loginComponent: JQuery;

        private $showLangBtn: JQuery;
        private $langComponent: JQuery;
        private $langCrt: JQuery;

        private $showSEOBtn: JQuery;
        private $seoComponent: JQuery;

        private $forgotPasswordLink: JQuery;
        private $forgotLink: JQuery;
        private $backToLoginLink: JQuery;
        private $loginForm: JQuery;
        private $forgotPasswordForm: JQuery;
        private $verifyIdentityForm: JQuery;

        private readonly AUTO_OPEN_LOGIN_QUERYSTRING_KEY = "showlogin";
        private readonly AUTO_OPEN_LOGIN_QUERYSTRING_VALUE = "true";

        constructor() {
            this.$showLoginBtn = $(".login35-nav-show-signin");
            this.$closeLoginBtn = $(".login35-nav-close-login");
            this.$showLoginBtnMobile = $(".login35-mobile-signin-btn");
            this.$closeLoginBtnMobile = $(".login35-nav-close-login-mobile");
            this.$loginComponent = $("#Login35Component");

            this.$showLangBtn = $("#languageSelector-expand");
            this.$langComponent = $("#Login35LanguagePanel");
            this.$langCrt = $(".show-lang-crt");

            this.$showSEOBtn = $(".login35-seo-burger");
            this.$seoComponent = $("#Login35SEOPanel");

            this.$forgotPasswordLink = $(".userlogin-links--forgotPassword");
            this.$forgotLink = $(".forgotLink");
            this.$backToLoginLink = $(".userlogin-links--backToLogin");
            this.$loginForm = $("#userLoginForm")
            this.$forgotPasswordForm = $("#forgotPasswordPanel");
            this.$verifyIdentityForm = $("#verifyIdentityPanel");

            this.bindEvents();
        }

        private bindEvents() {
            this.$showLoginBtn.on('click', () => this.showLogin());
            this.$closeLoginBtn.on('click', () => this.hideLogin());
            this.$showLoginBtnMobile.on('click', () => this.showLogin());
            this.$closeLoginBtnMobile.on('click', () => this.hideLogin());
            this.$showLangBtn.on('click', () => this.toggleDropdown("lang"));
            this.$showSEOBtn.on('click', () => this.toggleDropdown("seo"));
            this.$forgotPasswordLink.on('click', (e) => this.toggleForgotPassword(e));
            this.$backToLoginLink.on('click', (e) => this.toggleBackToLogin(e));

            this.checkForLoginAutoOpen();
        };

        private showLogin() {
            this.toggleDropdown("signin");
            this.updateQueryStringForLoginAutoOpen(true);
        }

        private hideLogin() {
            this.toggleDropdown("signin");
            this.updateQueryStringForLoginAutoOpen(false);
        }

        private checkForLoginAutoOpen() {
            const urlParams = new URLSearchParams(window.location.search);
            const showLogin = urlParams.get(this.AUTO_OPEN_LOGIN_QUERYSTRING_KEY);
            if (showLogin && showLogin === this.AUTO_OPEN_LOGIN_QUERYSTRING_VALUE) {
                this.showLogin();
            }
        }

        private updateQueryStringForLoginAutoOpen(show: boolean) {
            let state: URLSearchParams = new URLSearchParams(window.location.search);

            state.delete(this.AUTO_OPEN_LOGIN_QUERYSTRING_KEY);

            if (show) {
                state.append(this.AUTO_OPEN_LOGIN_QUERYSTRING_KEY, this.AUTO_OPEN_LOGIN_QUERYSTRING_VALUE);
            }

            history.replaceState(null, null, '?' + state.toString());
        }

        private toggleDropdown(type: string) {
            if (type === "seo") {
                if (this.$loginComponent.is(":visible")) {
                    this.$loginComponent.slideUp();
                }
                if (this.$langComponent.is(":visible")) {
                    this.$langComponent.slideUp();
                }
                this.$seoComponent.slideToggle();
            }
            else if (type === "lang") {
                if (this.$loginComponent.is(":visible")) {
                    this.$loginComponent.slideUp();
                }
                if (this.$seoComponent.is(":visible")) {
                    this.$seoComponent.slideUp();
                }

                if (this.$langComponent.is(":visible")) {
                    this.$langCrt.css('transform', 'scaleY(1)');
                }
                else {
                    this.$langCrt.css('transform', 'scaleY(-1)');
                }
                
                this.$langComponent.slideToggle();
            }
            else if (type === "signin") {
                if (this.$langComponent.is(":visible")) {
                    this.$langComponent.slideUp();
                }
                if (this.$seoComponent.is(":visible")) {
                    this.$seoComponent.slideUp();
                }

                if (this.$loginComponent.is(":visible")) {
                    this.$closeLoginBtn.hide();
                    this.$showLoginBtn.show();
                    this.$closeLoginBtnMobile.hide();
                    this.$showLoginBtnMobile.show();
                }
                else {
                    this.$closeLoginBtn.show();
                    this.$showLoginBtn.hide();
                    this.$closeLoginBtnMobile.show();
                    this.$showLoginBtnMobile.hide();
                }
                this.$loginComponent.slideToggle();
            }
        };

        private toggleForgotPassword(e: Event) {
            e.preventDefault();
            $('.auth-feedback').remove();

            this.$loginForm.hide();
            this.$forgotLink.hide();
            this.$forgotPasswordForm.css('display', 'flex');
            this.$verifyIdentityForm.hide();
        };

        private toggleBackToLogin(e: Event) {
            e.preventDefault();

            this.$loginForm.show();
            this.$forgotLink.show();
            this.$forgotPasswordForm.hide();
            this.$verifyIdentityForm.hide();
        };
    }
}